
import { VuetifyMixin, BAIconsMixin, AppHostnameMixin, StringsMixin, AthleteRoutingMixin, HelpInfoMixin, CoachRoutingMixin, } from '@/mixins';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { ScoutingReportModel } from '@/models/scoutingReport/ScoutingReportModel';
import { AthleteProfileModel } from '@/models';
import { AuthMixin, ScoutingReportMixin } from '@/mixins';
import ScoutingReportScoreChip from "@/components/scoutingReport/ScoutingReportScoreChip.vue";
import ScoutingScoreSummaryV3 from "@/components/scoutingReport/ScoutingScoreSummaryV3.vue"
import RadarChartJS from "@/components/charts/RadarChartJS.vue";
import SubscriptionInfoProvider from '@/components/hoc/SubscriptionInfoProvider.vue';

@Component({
	components: {
		ScoutingReportScoreChip,
		ScoutingScoreSummaryV3,
		RadarChartJS,
		SubscriptionInfoProvider
	}
})
export default class AthleteScoutingReportsCard extends Mixins(AuthMixin, AppHostnameMixin, BAIconsMixin, StringsMixin, VuetifyMixin, ScoutingReportMixin, AthleteRoutingMixin, CoachRoutingMixin, HelpInfoMixin){
	@Prop() scoutingReport: ScoutingReportModel;
	@Prop() athleteProfile: AthleteProfileModel;
	@Prop({ type: Boolean }) flat;
	@Prop({ type: Boolean }) buttons;
	@Prop({ type: Boolean }) history;
	@Prop({ type: Boolean }) extended;
	@Prop({ type: Boolean }) hideIfNoShare;

	searchScoutingReports = ""
	expanded: []
	scoutingReportHeaders: Array<DataTableHeader> = [
		{ text: 'Date', value: 'date', align: 'center', sortable: true},
		{ text: 'Location', value: 'location', filterable: true, sortable: false},
		{ text: 'Performance', value: 'performance', align: 'center', sortable: true},
		{ text: 'Potential', value: 'potential', align: 'center', sortable: true},
		{ text: '4 Corners', value: 'corners.score', align: 'center', sortable: false},
		{ text: '6 Moments', value: 'moments.score', align: 'center', sortable: false},
		{ text: 'C.R.I.S.P', value: 'crisp.score', align: 'center', sortable: false},
		{ text: '', value: 'actions', align: 'center', sortable: false},
		{ text: '', value: 'data-table-expand', sortable: false},
	]

	
	updatingFeatured: boolean = false;
	get HasScoutingReport(): boolean {
		return this.IsNotEmpty(this.scoutingReport);
	}
	get HasAthleteProfile(): boolean {
		return this.IsNotEmpty(this.athleteProfile);
	}

	ScoutingLabel(name: string, length: number = 6): string {
		if( this.IsEmpty(name) ) return '-';

		const keywords = ['Tactical', 'Technical', 'Mental', 'Physical']
		const lowerKeywords = keywords.map(k => k.toLowerCase());
		const trimmedName = name.trim();

		// Case-insensitive match with keyword
		if (lowerKeywords.includes(trimmedName.toLowerCase())) {
			return trimmedName;
		}

		// Name is short enough
		if (trimmedName.length < 9) {
			return trimmedName;
		}

		// Name has multiple words → return acronym
		const words = trimmedName.split(/\s+/);
		if (words.length > 1) {
			return words.map(w => w[0].toUpperCase()).join('');
		}

		// Fallback → return first N letters
		return trimmedName.substring(0, length);
	}

	get ShareReport(): boolean {
		if( !this.hideIfNoShare ) return true;
		return this.athleteProfile?.profileVisibility?.recruiter?.scoutingReport;
	}

}
